import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

type TransitionProps = {
	active?: boolean;
};

export const Header = styled.header<TransitionProps>`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	height: 44px;
	padding: 0 16px;
	margin-bottom: 10px;
	gap: 8px;
	cursor: pointer;
	z-index: 2;

	&:before {
		content: '';
		position: absolute;
		width: 30px;
		top: 2px;
		height: calc(100% - 4px);
		right: 4px;
		clip-path: polygon(0% 0%, 70% 0, 100% 50%, 70% 100%, 0% 100%);
		border-radius: 4px;
		z-index: -1;
		background: ${({ active }) =>
			active ? tokens.color_gray_light : tokens.color_white};
	}
`;

export const InfoCard = styled.div<TransitionProps>`
	display: grid;
	grid-template-columns: 20px 1fr;
	grid-gap: 10px;
	gap: 10px;
	position: relative;
	height: 0;
	overflow: hidden;
	transition: height 0.2s ease;
	border-radius: 6px;
	background: ${tokens.color_white};
	margin-bottom: 10px;
	box-shadow: 0px 10px 20px 0px rgba(216, 222, 230, 0.5);
	height: ${({ active }) => (active ? 'auto' : '0')};
	padding: ${({ active }) => (active ? '10px' : '0')};

	& > svg {
		margin-top: 2px;
	}
`;

export const HeaderActions = styled.div<TransitionProps>`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	padding: 0 10px;
	border-radius: 6px;

	background: ${({ active }) =>
		active ? tokens.color_gray_light : tokens.color_white};

	& > div > input[type='checkbox'] {
		height: 24px;
		margin: auto;
	}
`;
